import { useApi } from './use-api-call';

export const useSearchPagesContentApi = () =>
    useApi<{
        pagesContents: PagesContentDTO[];
        allowEdit: boolean;
    }>('/pages-content/search-pages-content/{pageId}');

export const useGetPagesContentApi = () =>
    useApi<{ pagesContent: PagesContentDTO; allowEdit: boolean }>(
        '/pages-content/get-pages-content/{id}'
    );

export const useSavePagesContentApi = () =>
    useApi<{ pagesContent: PagesContentDTO }>('/pages-content/save-pages-content');

export const useDeletePagesContentApi = () => useApi('/pages-content/delete-pages-content/{id}');

export interface PagesContentDTO {
    id?: number;
    pageId?: string;
    sectionOrder: number;
    heading: string;
    content: string;
}
